import { BANKING_ELIGIBILITY_STATUS } from '#client/constants/validationMessages';

export const REASONS_HIDE_OFFERS = [
  BANKING_ELIGIBILITY_STATUS.DOES_NOT_HAVE_FORMATION_ORDER,
  BANKING_ELIGIBILITY_STATUS.FORMATION_ORDER_INCOMPLETE
];
